//
//
//
//
//
//
//

import ReportManagementPage from '@/apps/data-platform/modules/report_management/reportManagementPage/ReportManagementPage.vue';
export default {
  components: {
    ReportManagementPage: ReportManagementPage
  },
  data: function data() {
    return {
      show_report: false,
      is_admin: true
    };
  },
  created: function created() {
    this.show_report = true;
  }
};